// Content is intentionally kept separate from the presentation so the advisory team
// can update services, process steps and FAQ answers without editing JSX.
export const businessProblems = [
  ["fa-diagram-project", "Quy trình vận hành thiếu đồng bộ", "Các phòng ban làm việc rời rạc, thiếu tiêu chuẩn và khó kiểm soát tiến độ."],
  ["fa-user-tie", "Hoạt động phụ thuộc vào cá nhân", "Nhiều công việc quan trọng phụ thuộc vào chủ doanh nghiệp hoặc nhân sự chủ chốt."],
  ["fa-people-group", "Đội ngũ chưa phát huy hết năng lực", "Thiếu cơ chế đào tạo, đánh giá và phát triển nhân sự rõ ràng."],
  ["fa-chart-column", "Khó kiểm soát dự án và chi phí", "Dữ liệu phân tán, báo cáo chậm và khó theo dõi hiệu quả từng dự án."],
  ["fa-compass", "Thiếu chiến lược tăng trưởng dài hạn", "Doanh nghiệp xử lý công việc theo tình huống nhưng chưa có lộ trình phát triển rõ ràng."],
  ["fa-arrows-to-circle", "Khó mở rộng quy mô", "Khi khách hàng và dự án tăng, hệ thống quản trị hiện tại không còn đáp ứng."],
];

export const methodPrinciples = [
  ["01", "Hiểu đúng hiện trạng doanh nghiệp", "Bắt đầu từ dữ liệu, con người và cách doanh nghiệp đang vận hành."],
  ["02", "Giải pháp phù hợp với thực tế", "Ưu tiên giải pháp có thể triển khai, đo lường và duy trì trong nội bộ."],
  ["03", "Đồng hành trong quá trình triển khai", "Cùng đội ngũ xử lý các điểm nghẽn và biến kế hoạch thành thói quen vận hành."],
  ["04", "Đo lường và cải tiến liên tục", "Theo dõi kết quả, rút kinh nghiệm và nâng cấp hệ thống theo từng giai đoạn."],
];

export const consultingProcess = [
  ["01", "Khảo sát hiện trạng", "Thu thập thông tin về mô hình kinh doanh, cơ cấu tổ chức, nhân sự và quy trình vận hành."],
  ["02", "Phân tích và xác định vấn đề", "Đánh giá những điểm nghẽn, rủi ro và cơ hội cải tiến trong doanh nghiệp."],
  ["03", "Xây dựng giải pháp", "Đề xuất lộ trình, mô hình quản trị và kế hoạch triển khai phù hợp."],
  ["04", "Triển khai đồng hành", "Hỗ trợ ứng dụng giải pháp, đào tạo đội ngũ và xử lý các vấn đề phát sinh."],
  ["05", "Đánh giá và tối ưu", "Theo dõi kết quả, đo lường hiệu quả và tiếp tục cải tiến hệ thống."],
];

export const consultingServices = [
  ["fa-chess", "Cố vấn chiến lược doanh nghiệp", "Xác định định hướng phát triển, mục tiêu và lộ trình tăng trưởng."],
  ["fa-gears", "Cố vấn quản trị vận hành", "Chuẩn hóa quy trình, trách nhiệm, biểu mẫu và cơ chế phối hợp."],
  ["fa-solar-panel", "Cố vấn quản trị dự án EPC", "Nâng cao khả năng kiểm soát tiến độ, nguồn lực, chất lượng và chi phí dự án."],
  ["fa-sitemap", "Cố vấn tổ chức và nhân sự", "Hoàn thiện cơ cấu tổ chức, chức năng nhiệm vụ và hệ thống đánh giá nhân sự."],
  ["fa-person-chalkboard", "Đào tạo đội ngũ quản lý", "Phát triển năng lực lãnh đạo, giao việc, kiểm soát và quản trị đội nhóm."],
  ["fa-laptop-code", "Chuyển đổi số quản trị", "Tư vấn ứng dụng công nghệ, dữ liệu và công cụ quản lý phù hợp."],
];

export const consultingBenefits = [
  "Hệ thống quản trị rõ ràng hơn.",
  "Quy trình vận hành được chuẩn hóa.",
  "Vai trò và trách nhiệm được phân định.",
  "Đội ngũ phối hợp hiệu quả hơn.",
  "Nhà quản lý có dữ liệu để ra quyết định.",
  "Doanh nghiệp có nền tảng để mở rộng quy mô.",
];

export const targetBusinesses = [
  ["fa-rocket", "Doanh nghiệp EPC đang tăng trưởng nhanh", "Cần củng cố hệ thống trước khi quy mô và số lượng dự án tăng lên."],
  ["fa-solar-panel", "Nhà thầu và đơn vị triển khai điện mặt trời", "Muốn kiểm soát tốt hơn chất lượng, tiến độ và hiệu quả dự án."],
  ["fa-arrows-rotate", "Doanh nghiệp đang tái cấu trúc hệ thống quản trị", "Cần một góc nhìn độc lập và lộ trình thay đổi có thứ tự ưu tiên."],
  ["fa-user-shield", "Chủ doanh nghiệp muốn giảm sự phụ thuộc vào cá nhân", "Xây dựng đội ngũ, quy trình và cơ chế ra quyết định bền vững hơn."],
];

// Mock profiles: replace these entries with approved team data when available.
export const experts = [
  ["../assets/images/team-1-1.jpg", "Chuyên gia cố vấn HiTech", "Cố vấn quản trị doanh nghiệp", "Chiến lược · Vận hành · Tổ chức"],
  ["../assets/images/team-1-2.jpg", "Chuyên gia dự án EPC", "Cố vấn quản trị dự án", "Tiến độ · Chi phí · Chất lượng"],
  ["../assets/images/team-1-3.jpg", "Chuyên gia phát triển đội ngũ", "Cố vấn tổ chức và nhân sự", "Lãnh đạo · Đào tạo · Hiệu suất"],
];

export const consultingFaq = [
  ["Dịch vụ cố vấn phù hợp với doanh nghiệp quy mô nào?", "Chương trình có thể bắt đầu từ doanh nghiệp đang xây nền tảng quản trị đến doanh nghiệp EPC/Solar đã có quy mô và cần chuẩn hóa để mở rộng."],
  ["Thời gian triển khai chương trình cố vấn kéo dài bao lâu?", "Thời gian được xác định sau bước khảo sát, tùy phạm vi ưu tiên, mức độ sẵn sàng và nguồn lực của từng doanh nghiệp."],
  ["HiTech có trực tiếp đồng hành trong quá trình triển khai không?", "Có. Cố vấn không dừng ở báo cáo đề xuất mà đồng hành cùng đội ngũ trong các bước ứng dụng và điều chỉnh."],
  ["Doanh nghiệp có được đào tạo đội ngũ nội bộ không?", "Có thể tích hợp các buổi đào tạo, hướng dẫn và chuyển giao theo nhu cầu của lộ trình cố vấn."],
  ["Chi phí cố vấn được xác định như thế nào?", "Chi phí phụ thuộc vào phạm vi, thời lượng và nguồn lực cần thiết. HiTech sẽ trao đổi rõ trước khi bắt đầu."],
  ["Sau chương trình có tiếp tục được hỗ trợ không?", "Doanh nghiệp có thể tiếp tục sử dụng các gói đồng hành, đánh giá định kỳ hoặc dịch vụ chuyên sâu theo nhu cầu."],
];
